import { Component, OnInit, OnDestroy, ViewChild, HostListener, AfterViewInit, ViewChildren } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as Chart from 'chart.js';
import { IssueService } from '../../../../services/issue.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { ClaimsService } from '../../../../services/claims.service';

@Component({
    selector: 'issues-history-chart',
    template: '<canvas style="height: 35rem" id="basechart" #basechart *ngIf="data.length; else noData"></canvas><ng-template #noData><p class="text-center">No data available</p></ng-template>',
    styles: [':host { position: relative; display:block; }']    
})
export class IssuesHistoryChartComponent implements OnDestroy, AfterViewInit {

    @ViewChildren('basechart') basechart: any;
    chart: any;
    subscriptions: any[] = [];
    debounceTimeout = 2000;
    debounceId: any;
    consumerId: string;
    data: any[] = [];
    paygData: any[] = [];
    billingData: any[] = [];
    consumptionData: any[] = [];
    pipe: DatePipe = new DatePipe('en_GB');
    clientId: number;

    constructor(
        private claimsService: ClaimsService,
        private issueService: IssueService,
        private route: ActivatedRoute,
        private router: Router) {


    }

    ngAfterViewInit(): void {
        this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        });
    }

    onInitialise() {
        this.clientId = this.route.parent.parent.snapshot.params['clientId'];
        this.issueService.getIssueHistory(this.clientId).then((result: any) => {

            this.data = result;
            if (this.claimsService.hasPaygFeature() || this.claimsService.isSuperUser()) {
                this.paygData = result
                    .filter(x => x.issueType == 'PAYG')
                    .map(item => {
                        return {
                            x: item.monthYear.toString(),
                            y: item.issueCount
                        }
                    });
            }


            if (this.claimsService.hasBillingFeature() || this.claimsService.isSuperUser()) {
                this.billingData = result
                    .filter(x => x.issueType == 'Billing')
                    .map(item => {
                        return {
                            x: item.monthYear.toString(),
                            y: item.issueCount
                        }
                    });
            }

            if (this.claimsService.hasConsumptionFeature() || this.claimsService.isSuperUser()) {
                this.consumptionData = result
                    .filter(x => x.issueType == 'Metering')
                    .map(item => {
                        return {
                            x: item.monthYear.toString(),
                            y: item.issueCount
                        }
                    });
            }

            let data = this.consumptionData.concat(this.billingData).concat(this.paygData).map(x=>x.x);
            data = data.filter((value, index, self) => {
                return self.indexOf(value) === index;
            });


            let missingPaygData = data.filter((value, index, self) => {
                return this.paygData.find(y => y.x == value) == undefined;
            });

            missingPaygData.forEach(item => {
                this.paygData.push({
                    x: item,
                    y: 0
                })
            })

            let missingBillingData = data.filter((value, index, self) => {
                return this.billingData.find(y => y.x == value) == undefined;
            });

            missingBillingData.forEach(item => {
                this.billingData.push({
                    x: item,
                    y: 0
                })
            })


            let missingConsumptionData = data.filter((value, index, self) => {
                return this.consumptionData.find(y => y.x == value) == undefined;
            });

            missingConsumptionData.forEach(item => {
                this.consumptionData.push({
                    x: item,
                    y: 0
                })
            })

            this.paygData = this.paygData.sort((a, b) => {
                let c = new Date(a.x) as any;
                let d = new Date(b.x) as any;
                return c - d;
            });


            this.billingData = this.billingData.sort((a, b) => {
                let c = new Date(a.x) as any;
                let d = new Date(b.x) as any;
                return c - d;
            });


            this.consumptionData = this.consumptionData.sort((a, b) => {
                let c = new Date(a.x) as any;
                let d = new Date(b.x) as any;
                return c - d;
            });

            if (this.paygData.length || this.billingData.length || this.consumptionData.length) this.createChart();
        });
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
        if (this.debounceId) {
            clearTimeout(this.debounceId);
        }
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.createChart();
    }

    private getChartConfig(): any {
        let config = {
            type: 'bar',
            options: {
                 maintainAspectRatio: false,
                legend: {
                    display: true,
                   
                },
                tooltips: {
                    mode: 'index',
                    enabled: true,
                    backgroundColor: '#ffffff',
                    titleFontColor: '#153954',
                    bodyFontColor: '#153954',
                    borderWidth: 2,
                    borderColor: '#009aa3',
                    callbacks: {
                            title: function (tooltipItems, data) {
                                //Return value for title
                                let datePipe: DatePipe = new DatePipe('en_GB');
                                return datePipe.transform(tooltipItems[0].xLabel,'MMMM');
                            },
                        label: function (tooltipItem, data) {
                            var allData: any = data != null && data.datasets != null && tooltipItem != null && tooltipItem.datasetIndex != null ? data.datasets[tooltipItem.datasetIndex].data : [];
                            var hoverData: any = data != null && data.datasets != null && tooltipItem != null && tooltipItem.datasetIndex != null ? data.datasets[tooltipItem.datasetIndex] : [];
                            var tooltipLabel: any = data != null && data.labels != null && tooltipItem != null && tooltipItem.index != null ? data.labels[tooltipItem.index] : [];
                            var tooltipData: any = allData != null && allData.length > 0 && tooltipItem != null && tooltipItem.index != null ? allData[tooltipItem.index] : [];
                            if (tooltipData.y == 0) return;
                            return hoverData.label + ' ' + tooltipData.y;
                        }
                    }
                },
                scales: {
                    xAxes: [{
                        ticks: {
                            autoSkip: true,
                        },
                        offset: true,
                        stacked: true,
                        barThickness: 20,
                        scaleLabel: {
                            display: true,
                            labelString: 'Date',
                            fontSize: 15,
                            fontStyle: "bold",
                        },
                        type: 'time',
                        time: {
                            displayFormats: {
                                month: 'MMM'
                            },
                            unit: 'month',
                        },
                        gridLines: {
                            display: false
                        },
                    }],
                    yAxes: [
                        {
                            stacked: true,
                            id: "y-axis-0",
                            position: 'left',
                            scaleLabel: {
                                display: true,
                                labelString: 'Issues Count',
                                fontSize: 15,
                                fontStyle: "bold",
                            },
                            ticks: {
                                beginAtZero: true,
                            },
                            gridLines: {
                                display: true
                            }
                        },
                    ]
                }
            }
        }

        return config;
    }

    createChart() {
        if (this.chart != null) this.chart.destroy();
        if (!this.basechart) return;

        let datasets = [] as any;

        if (this.paygData.length > 0 && this.claimsService.hasPaygFeature()) {
            datasets.push({
                label: 'PAYG',
                yAxisID: 'y-axis-0',
                data: this.paygData,
                backgroundColor: '#153954',
                borderColor: '#153954', 
            });
        }

        if (this.billingData.length > 0 && this.claimsService.hasBillingFeature()) {
            datasets.push({
                label: 'Billing',
                yAxisID: 'y-axis-0',
                data: this.billingData,
                backgroundColor: '#009aa3',
                borderColor: '#009aa3',
            });

        }

        if (this.consumptionData.length > 0 && this.claimsService.hasConsumptionFeature()) {
            datasets.push({
                label: 'Metering',
                yAxisID: 'y-axis-0',
                data: this.consumptionData,
                backgroundColor: '#9eb3be',
                borderColor: '#9eb3be',
            });

        }

        let config = this.getChartConfig();
        let chartConfiguration: Chart.ChartConfiguration = {
            type: config.type,
            options: config.options,
            data: { datasets: datasets }
        };

        if (this.debounceId) {
            window.clearTimeout(this.debounceId);
        };

        this.debounceId = window.setTimeout(() => {
            if (this.chart != null) this.chart.destroy();
            let ctx = this.basechart.first.nativeElement;
            this.chart = new Chart(ctx, chartConfiguration);
        }, this.debounceTimeout);
    }


}
